// Vendor imports
const { connect } = require('react-redux')
const { MemoryRouter } = require('react-router')

function mapStateToProps(initialState) {
  // https://reacttraining.com/react-router/web/api/MemoryRouter/initialentries-array
  const initialEntries = [
    initialState.router.location.href
  ]
  return function () {
    return { initialEntries }
  }
}

module.exports = connect(
  mapStateToProps
)(
  MemoryRouter
)
